import { Component, Inject } from "@angular/core";
import { AbstractControl, FormControl, ReactiveFormsModule, ValidatorFn, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import { ConfirmDeleteDialogData, ConfirmDeleteDialogResult } from "../ConfirmDialogDatas";
import { MaterialModule } from "../../shared/material.module";
import { CommonModule } from "@angular/common";

// Validator personalizat pentru a verifica potrivirea textului
export function matchStringValidator(expected: string): ValidatorFn {
  return (control: AbstractControl) => {
    return control.value === expected ? null : { mismatch: true };
  };
}

@Component({
  standalone: true,
  imports: [MatDialogModule, MaterialModule, TranslateModule, ReactiveFormsModule, CommonModule],
  templateUrl: './delete-dialog.component.html',
  styleUrl: './delete-dialog.component.scss'

})
export class DeleteDialogComponent {
  confirmControl = new FormControl('', { nonNullable: true });
  reasonControl = new FormControl("", { nonNullable: true });

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDeleteDialogData) {}

  get showReason(): boolean {
    return this.data.requiredReason || this.data.optionalReason;
  }

  get isReasonRequired(): boolean {
    return this.data.requiredReason;
  }

  get isFormInvalid(): boolean {
    if (this.confirmControl.invalid) return true;
    if (this.isReasonRequired && this.reasonControl.invalid) return true;
    return false;
  }

  ngOnInit(): void {
    // Adăugăm validatorul folosind string-ul primit prin data.requiredString
    this.confirmControl.setValidators([
      Validators.required,
      matchStringValidator(this.data.requiredString)
    ]);

    if (this.showReason) {
      if (this.isReasonRequired) {
        this.reasonControl.setValidators([Validators.required, Validators.minLength(5)]);
      }
    }
  }
  
  buildResult(confirmed: boolean): ConfirmDeleteDialogResult {
    const reason = this.showReason ? this.reasonControl.value.trim() : "";
    return {
      confirmed,
      reason: reason.length ? reason : undefined,
    };
  }

}
export type { ConfirmDeleteDialogData, ConfirmDeleteDialogResult };
